import { getDomainDetail } from "../api";
import { generateDeviceId } from "./generateDeviceId";
import { pickLandingStatic } from "./pickLandingDomain";

let cached = null;
let pending = null;

function applyLandingBranding(data) {
  if (!data || typeof data !== "object") return;

  const title = data.title;
  if (title) {
    document.title = String(title);
  }
}

/** 只请求一次 latestAddress（避免 StrictMode 下 useEffect 重复调用） */
export function loadLandingStatic() {
  if (cached) return Promise.resolve(cached);
  if (pending) return pending;

  pending = Promise.resolve()
    .then(async () => {
      const deviceId = await generateDeviceId();
      const res = await getDomainDetail(deviceId);
      const data = res?.data?.data;
      applyLandingBranding(data);
      return pickLandingStatic(data);
    })
    .catch((err) => {
      console.warn("[loadLandingStatic] 请求失败，使用默认落地页", err);
      return pickLandingStatic(null);
    })
    .then((url) => {
      cached = url;
      return url;
    })
    .catch((err) => {
      console.warn("[loadLandingStatic] 兜底失败", err);
      cached = pickLandingStatic(null);
      return cached;
    })
    .finally(() => {
      pending = null;
    });

  return pending;
}
